import { MessageCircle } from "lucide-react";

const DAY = ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"];
const MON = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];

export const buildInviteText = ({ businessName, lesson, date, startTime, endTime, link }) => {
  const [y, m, d] = date.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  return `Ben bu derse katılıyorum, sen de gel! 💪\n\n${businessName ? `${businessName} · ` : ""}${lesson || "Ders"}\n📅 ${d} ${MON[m - 1]} ${DAY[dt.getDay()]} · ${startTime}–${endTime}\n\nYerini buradan ayırt: ${link}`;
};

export const InviteFriendButton = ({ testId, className = "", ...info }) => (
  <a
    href={`https://wa.me/?text=${encodeURIComponent(buildInviteText(info))}`}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className={`inline-flex items-center justify-center gap-1.5 rounded-xl bg-[#25D366] hover:bg-[#1ebe5a] text-white font-medium transition-colors ${className}`}
  >
    <MessageCircle className="w-4 h-4" /> Arkadaşını Getir
  </a>
);
